<template>
    <div>
        <Table border :columns="columns1" :data="data1" :span-method="handleSpan">
             <template slot-scope="{ row ,index }" slot="targetItem">
                <Input type="textarea" v-model="row.targetItem" :autosize="true" @on-change="targetItemChange(row,index,'targetItem')" />
            </template>
            <template slot-scope="{ row ,index }" slot="content" style="width:100%">
                <Input type="textarea" v-model="row.content" :autosize="true" @on-change="targetItemChange(row,index,'content')"/>
            </template>
            <template slot-scope="{ row,index }" slot="weight">
               <DatePicker type="date" v-model="row.weight" :transfer='true' :clearable='false' @on-change="targetItemChange(row,index,'weight')"/>
            </template>
            <template slot-scope="{ row,index }" slot="method">
                <DatePicker type="date" v-model="row.method" :transfer='true' :clearable='false' @on-change="targetItemChange(row,index,'method')"/>
            </template>
            <template slot-scope="{ row,index }" slot="milepost">
                <Input type="textarea" v-model="row.milepost" :disabled="true" :autosize="true" @on-change="targetItemChange(row,index,'milepost')"/>
            </template>
            <template slot-scope="{ row,index }" slot="milepostInput">
                <Input type="textarea" v-model="row.milepostInput"  :autosize="true" @on-change="targetItemChange(row,index,'milepostInput')"/>
            </template>
            <template slot-scope="{ row,index }" slot="dataFrom">
                <Input type="textarea" v-model="row.dataFrom" :autosize="true" @on-change="targetItemChange(row,index,'dataFrom')"/>
            </template>
            <template slot-scope="{ row, index }" slot="action1">
                 <Upload :action="action" :show-upload-list="false" :on-success="(response,file,fileList) =>uploadFiled(response,file,fileList,row)" :on-error="handleUpload" >
                      <Icon type="ios-create" style="font-size: 30px" color="#8CD29B" @click="editSTI(row, index)"></Icon>
                </Upload>
                <span>{{row.filedName}}</span>
                <Icon v-if="row.filedName" type="md-trash" style="color:red" @click="clearFiled(row)"/>
            </template>
            <template slot-scope="{ row, index }" slot="action12">
              <Button icon="md-trash" type="warning" size="small" @click="deleteSTI(row,index)"></Button>
            </template>
          </Table>
          <div style="display: flex; justify-content: flex-end; margin-top:10px">
            <Button @click="addSTI()">新增</Button>
          </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            columns1: [
                {
                    title: "STI",
                    slot: "targetItem",
                    minWidth:160,
                },
                {
                    title: "详情描述",
                    slot: "content",
                    align: "center",
                    minWidth:300,
                },
                {
                    title: "开始时间",
                    slot: "weight",
                    align: "center",
                    minWidth:160,
                },
                {
                    title: "结束时间",
                    slot: "method",
                    align: "center",
                    minWidth:160,
                },
                {
                    title: "里程碑",
                    align: "center",
                    children: [
                        {
                            slot: "milepost",
                            align: "center",
                            minWidth:160,
                            
                        },
                        {
                            slot: "milepostInput",
                            align: "center",
                            minWidth:160,
                        }
                    ]
                },
                {
                    title: "数据来源",
                    slot: "dataFrom",
                    align: "center",
                    minWidth:220,
                },
                {
                    title: "附件",
                    slot:"action1",
                    align: "center",
                    minWidth: 80,
                },
                {
                    title: "操作",
                    slot:"action12",
                    align: "center",
                    minWidth: 80,
                },
            ],
            data1:[],
            spanb:[],
            stiId:0,
            action: "/api/resource/upload",
        }
    },
    methods:{
        handleSpan ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 1 || columnIndex === 0 || columnIndex === 2 || columnIndex === 3 || columnIndex === 8 || columnIndex === 6 || columnIndex === 7) {
                if(this.spanb[rowIndex]){
                    return {
                        rowspan:this.spanb[rowIndex],
                        colspan:1
                    }
                }else{
                    return {
                        rowspan: 0,
                        colspan: 1
                    }
                }
            }
        },
        addSTI(){
            this.stiId++
            for(let i=1;i<=3;i++){
                this.data1.push({targetItem:'个人目标',content:'详情描述',weight:'',method:'',dataFrom:'',milepost:'里程碑'+i,milepostInput:'',stiid:this.stiId})
            }
            let contactDotb = 0;
            let spanb = [];
            this.data1.forEach((item,index)=>{
                if(index === 0){
                    spanb.push(1)
                }else {
                    if (item.stiid === this.data1[index - 1].stiid) {
                        spanb[contactDotb] += 1;
                        spanb.push(0)
                    } else {
                        contactDotb = index
                        spanb.push(1)
                    }
                }
            })
            this.spanb = spanb;
        },
        editSTI(row,index){

        },
        deleteSTI(row,i){
            this.data1.splice(i,3)
        },
         targetItemChange(row,index,key){
            key=='targetItem'?this.$set(this.data1[index],'targetItem',row.targetItem):''
            key=='weight'?this.$set(this.data1[index],'weight',row.weight):''
            key=='content'?this.$set(this.data1[index],'content',row.content):''
            key=='method'?this.$set(this.data1[index],'method',row.method):''
            key=='milepost'?this.$set(this.data1[index],'milepost',row.milepost):''
            key=='milepostInput'?this.$set(this.data1[index],'milepostInput',row.milepostInput):''
            key=='dataFrom'?this.$set(this.data1[index],'dataFrom',row.dataFrom):''
        
        },
        uploadFiled(response, file, fileList,row){
            console.log(file)
            console.log(row)
            this.data1.forEach((res,index) => {
                if(res.stiid==row.stiid){
                    this.$set(this.data1[index],'filedName',file.name)
                }
            })
        
        },
        clearFiled(row){
            this.data1.forEach((res,index) => {
                if(res.stiid==row.stiid){
                    this.$set(this.data1[index],'filedName','')
                }
            })
        },
        handleUpload(error){
        },
    }
}
</script>

<style lang="less" scoped>
/deep/.ivu-table-header table thead tr:nth-child(2){
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/process/Apply/components/STIComponent.vue